import { Box, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { formatLastMessageSinceTime } from 'src/utils/date';

const SINCE_TIME_REFRESH_TIMER_MS = 60000;

export const SinceTimeCell = ({ date }: { date?: string }) => {
  // eslint-disable-next-line react/hook-use-state
  const [_, setCurrentTime] = useState(new Date());

  useEffect(() => {
    // simple counter to increment/rerender date value every minute
    const interval = setInterval(() => {
      setCurrentTime(new Date());
    }, SINCE_TIME_REFRESH_TIMER_MS); // Update every minute

    return () => clearInterval(interval);
  }, []);

  return (
    <Box>
      <Typography
        variant="body1"
        fontSize="small"
        sx={{ whiteSpace: 'nowrap' }}
        component="span"
      >
        {formatLastMessageSinceTime(date)}
      </Typography>
    </Box>
  );
};
